module.exports = __webpack_public_path__ + "img/lunch.d65ad32b.svg";